import React, { Component } from "react";
import ReactDom from "react-dom";
import PropTypes from "prop-types";

const modalRoot = document.getElementById("modal-root");

class ModalNotification extends Component {
  static defaultProps = {
    id: "",
    modalClass: "",
    modalSize: "md",
    backgroundColor: "#fff",
  };

  static propTypes = {
    id: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    modalClass: PropTypes.string,
    modalSize: PropTypes.string,
    modalHeight: PropTypes.string,
    backgroundColor: PropTypes.string,
    children: PropTypes.node,
  };

  state = { fadeType: null };
  background = React.createRef();

  componentDidMount() {
    window.addEventListener("keydown", this.onEscKeyDown, false);
    setTimeout(() => this.setState({ fadeType: "in" }), 0);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.setState({ fadeType: "out" });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onEscKeyDown, false);
  }

  transitionEnd = (e) => {
    if (e.propertyName !== "opacity" || this.state.fadeType === "in") return;

    if (this.state.fadeType === "out") {
      this.props.onClose();
    }
  };

  onEscKeyDown = (e) => {
    if (e.key !== "Escape") return;
    this.setState({ fadeType: "out" });
  };

  handleClick = (e) => {
    e.preventDefault();
    this.setState({ fadeType: "out" });
  };

  getModalWidth = () => {
    switch (this.props.modalSize) {
      case "large":
        return "95vw";
      case "small":
        return "480px";
      case "medium":
        return "900px";
      default:
        return "480px";
    }
  };

  render() {
    if (!modalRoot) return null;

    const wrapperStyle = {
      ...styles.wrapper,
      opacity: this.state.fadeType === "in" ? 1 : 0,
      width: this.getModalWidth(),
    };

    const boxDialogStyle = {
      ...styles.boxDialog,
      backgroundColor: this.props.backgroundColor || "#fff",
    };

    // Use the exact size of your borderRadius (25px) for the safety zone
    const safetyZoneStyle = {
      height: "25px",
      flexShrink: 0,
      width: "100%",
    };

    return ReactDom.createPortal(
      <div
        id={this.props.id}
        className={`wrapper ${"size-" + this.props.modalSize} ${
          this.props.modalClass
        }`}
        role="dialog"
        style={wrapperStyle}
        onTransitionEnd={this.transitionEnd}
      >
        <div className="box-dialog" style={boxDialogStyle}>
          {/* 1. TOP SAFETY ZONE */}
          <div style={safetyZoneStyle} />

          <div className="box-content" style={styles.boxContent}>
            {this.props.children}
          </div>

          {/* 2. BOTTOM SAFETY ZONE */}
          <div style={safetyZoneStyle} />
        </div>

        <div
          className="background"
          style={styles.background}
          onMouseDown={this.handleClick}
          ref={this.background}
        />
      </div>,
      modalRoot,
    );
  }
}

// --- CSS Objects ---

const styles = {
  wrapper: {
    position: "fixed",
    top: "65px",
    right: "10px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    zIndex: 2000,
    maxWidth: "calc( 100vw - 20px )",
    margin: "auto",
    transition: "opacity 0.1s",
    WebkitTransition: "opacity 0.1s",
    MozTransition: "opacity 0.1s",
    OTransition: "opacity 0.1s",
  },
  background: {
    background: "#1f6fae2a",
    position: "fixed",
    zIndex: 1040,
    display: "block",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    outline: 0,
  },
  boxDialog: {
    borderRadius: "25px",
    zIndex: 1050,
    width: "100%",
    boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.071)",
    // --- UPDATES START ---
    display: "flex", // Enables Flexbox
    flexDirection: "column", // Stacks items vertically
    overflow: "hidden", // Ensures nothing sticks out of the rounded corners
    maxHeight: "calc(100vh - 177px)", // Moved max-height here so the container controls size
    // --- UPDATES END ---
  },
  boxContent: {
    fontSize: "14px",
    padding: "0 25px", // Removed vertical padding (handled by safety zones now)
    // --- UPDATES START ---
    flex: "1 1 auto", // Takes up remaining space
    overflowY: "auto", // Scrolls only this section
    overflowX: "auto",
    // maxHeight removed from here
    // --- UPDATES END ---
  },
};

export default ModalNotification;
